import React from 'react';
import BoostedComponent from './BoostedComponent'
import moment from 'moment-with-locales-es6';
import TimeInput from './TimeInput';

class ReservationSeuleSelection extends BoostedComponent {
  constructor (props) {
    super(props)
    this.state = {
      duree: "",
      plageChoisie: this.props.plageChoisie,
      heureMin: (this.props.plageChoisie) ? this.props.plageChoisie[0]%(24*60*60) : '',
      heureMax: (this.props.plageChoisie) ? (this.props.plageChoisie[1] ? this.props.plageChoisie[1]%(24*60*60) : 24*60*60) : '',
      problem: ""
    }
    if (this.state.heureMax <= this.state.heureMin) {
      this.state.heureMax += 24*60*60
    }
    this.semaines = [];
    for (let i=0; i < 24;i++) {

      this.semaines.push((i<10 ? "0"+i : i)+":00",(i<10 ? "0"+i : i)+":30")
    }
    this.semaines.push("24:00");
    this.constants = this.props.constants
  }
  componentDidMount() {
    this.validateTime();
  }
  componentDidUpdate(prevProps,prevState) {
    
    if (
      this.props.plageChoisie !== prevProps.plageChoisie ||
      this.props.heureDebut !== prevProps.heureDebut ||
      this.props.heureFin !== prevProps.heureFin ||
      this.props.page !== prevProps.page
    ) {

      let newState = {
        plageChoisie: this.props.plageChoisie,
        heureMin: (this.props.plageChoisie) ? this.props.plageChoisie[0]%(24*60*60) : '',
        heureMax: (this.props.plageChoisie) ? (this.props.plageChoisie[1] ? this.props.plageChoisie[1]%(24*60*60) : 24*60*60) : ''
      }
    
      if (newState.heureMax <= newState.heureMin) {
        newState.heureMax = newState.heureMax+(24*60*60) 
      }
      
      let debut = this.string2temps(this.props.heureDebut)*60*60;
      let fin = this.props.heureFin ? this.string2temps(this.props.heureFin)*60*60 : 24*60*60;
      
      let jour = (newState.heureMax < newState.heureMin) ? 24*3600 : 0;



      if (debut >= newState.heureMin && fin <= newState.heureMax+jour) {

        newState.heureDebut =  this.props.heureDebut;
        newState.duree = this.temps2string(fin - debut,false)
      } 
      else if (
        fin <= newState.heureMax
      ) {  
        newState.heureDebut =  this.temps2string(this.string2temps(this.temps2string(newState.heureMin))*3600);
        newState.duree = this.temps2string(fin - debut,false)
        
      } 
        else if (
        debut >= newState.heureMin
      ) {
        newState.heureDebut =  this.temps2string(this.string2temps(this.temps2string(newState.heureMax - (fin - debut)))*3600);
        newState.duree = this.temps2string(fin - debut,false)
        
      }
      this.validateTime();
      this.setState(newState);
      

    }
    if (
      this.state.heureDebut !== prevState.heureDebut ||
      this.state.duree !== prevState.duree ||
      this.state.heureMin !== prevState.heureMin ||
      this.state.heureMax !== prevState.heureMax
    ) {
      this.validateTime();
    }
  }
  validateTime = (a,b) => {
    let de = (a) ? a.target.value : this.state.heureDebut
    let du = (b) ? b.target.value : this.state.duree;

    let debut = this.string2temps(de)*3600;
    let duree = this.string2temps(du)*3600;
    let fin = debut+duree

let heureMax = this.state.heureMax
let heureMin = this.state.heureMin

if (heureMin > heureMax) {
  heureMax = heureMax+(24*3600)
}
if (debut < heureMin) {
  
  debut += 24*3600
}
if (fin < heureMin) {
  fin += 24*3600
}

    let probleme = "";

    if ((debut <heureMin || fin > heureMax)) {
      
        probleme = this.props.constants.problemePlage     
    } else if (
      (
        (debut - heureMin < this.props.constants.espacementMax)
        ||  (heureMax - fin < this.props.constants.espacementMax)
      )

      && (debut - heureMin > 0)
      && (heureMax - fin > 0)
    ) {
      probleme = this.props.constants.problemeEspacement
    }
    this.setState({
      heureDebut: de,
      duree: du,
      probleme: probleme
    })
    if (probleme) {
      this.props.parent.setState({
        aReserver: []
      })
    } else {
      if (this.state.plageChoisie) {
        let dateDebut = new Date(parseInt(this.state.plageChoisie[0],10)*1000)
        dateDebut.setUTCHours(0);
        dateDebut.setUTCMinutes(0);
        dateDebut.setUTCSeconds(0);
        dateDebut.setUTCMilliseconds(0);
        this.props.parent.setState({
          aReserver: [
            {
              debut: debut + dateDebut.getTime()/1000,
              fin: fin + dateDebut.getTime()/1000,
              plateau: parseInt(this.state.plageChoisie[2])
            }
          ]
        })
      }
    }

  }
  render() {
    moment.locale('fr')
    return(
      <div className="ReservationSeule3">
        <h3>{this.props.constants.selection}</h3>
        {this.state.plageChoisie &&
          <div>
            <p className="resume">  {moment.utc(parseInt(this.state.plageChoisie[0],10)*1000).format('dddd, LL')} { this.constants.entre} {moment.utc(parseInt(this.state.plageChoisie[0],10)*1000).format('H:mm')}  { this.constants.et} {moment.utc(parseInt(this.state.plageChoisie[1],10)*1000).format('H:mm')}
            </p>
            <p className="instructions">{this.constants.instructionsReservSeulePlage}</p>
            <div className="fieldLine">
              <div className="label">
                <label>{this.constants.heureDebut}</label>

                    <select onChange={(e)=>{
                                  this.validateTime(e,null);
                              }} value={this.state.heureDebut}>
                                  {this.semaines.filter(t => {
                                    if (
                                      this.string2temps(t)*3600 < this.state.plageChoisie[0]%(24*3600) && 
                                      this.string2temps(t)*3600 < this.state.plageChoisie[0]%(24*3600)+(24*3600)
                                    ) return false;
                                    if (
                                      this.string2temps(t)*3600+this.string2temps(this.state.duree)*3600 > this.state.plageChoisie[1]%(24*3600) &&
                                      (this.string2temps(t)-24)*3600+this.string2temps(this.state.duree)*3600 > this.state.plageChoisie[1]%(24*3600)
                                      ) return false;
                                    return true;
                                  }).map(i=>
                                    <option key={i} value={i}>{i}</option>
                                  )}
                                </select>
              </div>
              <div className="label">
                <label>{this.constants.tempsGlace}</label>
                <input type="text" disabled value={this.temps2string((this.string2temps(this.state.heureDebut)*3600 + this.string2temps(this.state.duree)*3600)%(24*3600), true)} />
              </div>
            </div>

            <p style={{ color: "red" }}>{this.state.probleme}</p>
          </div>
        }
      </div>
    )
  }
}
export default ReservationSeuleSelection;



// WEBPACK FOOTER //
// ./src/ReservationSeule3.js